import type { Locale } from '@iac/contracts';
import { useLocale } from '../lib/locale';

/**
 * One scope's strings in every UI language. Declare `pl` first and type `en` as
 * `typeof pl`: a key missing from either side, or one with the wrong shape, is
 * then a type error rather than a blank in production.
 */
export type Dictionary<T> = Readonly<Record<Locale, T>>;

/** The strings for the language the screen currently renders in. */
export function useDict<T>(dict: Dictionary<T>): T {
  return dict[useLocale().locale];
}
